const initialState = () => ({
  staffStatus: [],
  agencyStaffStatus: [],
  agencySecondaryStaffStatus: [],
})

const getters = {
  STAFF_STATUS: state => state.staffStatus,
  AGENCY_STAFF_STATUS: state => state.agencyStaffStatus,
  AGENCY_SECONDARY_STAFF_STATUS: state => state.agencySecondaryStaffStatus,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_MAPPING (state, payload) {
    state.staffStatus = payload.staffStatus
    state.agencyStaffStatus = payload.agencyStaffStatus
    state.agencySecondaryStaffStatus = payload.agencySecondaryStaffStatus
  },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
